module.exports = __webpack_public_path__ + "img/2.58e46a93.webp";